module.exports = "embed {\n  margin-top: -3.14285714rem;\n  width: 100%;\n  height: calc(100vh - 5px);\n  padding: 0;\n  margin-bottom: -5px; }\n"